import { makeStyles } from '@material-ui/core/styles';
import { modalPaperStyle } from '../../shared/components/RedesignModal/RedesignModal.styles';
import { primaryButtonStyle, secondaryButtonStyle } from '../../shared/styles/buttons.styles';
import { redesignTheme } from '../../theme';

const { sizes, colors, fonts, fontSize, spacing } = redesignTheme;

export const useCandidatureModalStyles = makeStyles(() => ({
  modal: {
    ...modalPaperStyle,
    maxWidth: sizes.modalMaxWidth,
  },
  title: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.lg,
    color: colors.primaryDark,
    lineHeight: 1.4,
  },
  message: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.base,
    color: colors.text,
    lineHeight: 1.5,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing.sm,
    justifyContent: 'flex-end',
  },
  confirmButton: {
    ...primaryButtonStyle,
  },
  cancelButton: {
    ...secondaryButtonStyle,
  },
  loadingWrap: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: spacing.xs,
  },
}));
